import {CampaignContract} from '@/types/campaignContract';
import campaignFetchers from '@/api/fetchers/campaign';
import useDataQuery from '@/hooks/use-data-query';

function useCampaignContractsQuery({campaignId}: {campaignId: string}) {
  return useDataQuery<CampaignContract[]>({
    queryKey: ['campaignContracts', campaignId],
    queryFn: campaignFetchers.campaignContracts,
    refetchOnWindowFocus: false,
    meta: {
      id: campaignId,
    },
  });
}
export default useCampaignContractsQuery;
